<template>
    <div>
        <Separator :label="$t('page.people')"></Separator>
        <div class="container-fluid__with-padding">
            <div class="row justify-content-center">
                <div class="col-12 people">
                    <div v-for="person in sortedList" class="people__item">
                        <Person :person="person"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Separator from './Separator'
    import Person from "./Person";

    export default {
        name: "PeopleList",
        components: {
            Separator,
            Person
        },
        props: {
            people : null
        },
        computed: {
            sortedList: function() {
                return this.people.map((x) => x).sort(function (a, b) {
                    return a.compare.toLowerCase().localeCompare(b.compare.toLowerCase(), 'fr', { sensitivity: 'base'})
                })
            }
        },
    }
</script>

